<template>
  <el-dialog
      v-model="isShow"
      :footer="null"
      :title="$t('common.ai.history')"
      centered
      top="6em"
      :width="720"
      style="min-width:300px;height: 540px"
      :modal="true"
      @cancel="close"
      custom-class="dialog-class"
      :close-on-click-modal="false"
  >
    <!--    <template #header>-->
    <!--      <div>-->
    <!--        <span>{{ $t('common.ai.history') }}</span>-->
    <!--       -->
    <!--      </div>-->
    <!--    </template>-->
    <template #default style="padding: 0px !important;">
      <div v-if="isLoading" v-loading="isLoading" style="height: 450px"></div>
      <div v-else>
        <div class="history-content" ref="historyContent" @scroll="loadMore" v-if="chatDetailList.length>0">
          <div class="item" v-for="(item,index) in chatDetailList" :key="item"
               @click.stop="handleClickItemDetail(item)">
            <div class="top">
              <div v-if="editingItemId === item.id" style="width: 300px">
                <el-input
                    v-model="editText"
                    @blur="handleSaveEdit(item)"
                    @keydown.enter="handleSaveEdit(item)"
                    ref="editInput"
                    @input="handleCheck"
                />
                <span v-if="isError"
                      style="color: red;font-size: 12px;margin-top: 10px">{{ $t('common.ai.empty') }}</span>
              </div>
              <div v-else class="title">
                {{ item.conversation }}
              </div>
              <div class="tools">
                <img @click.stop="handleClickDetailEdit(item,index)" src="@/assets/AI/edit.png"
                     style="width: 14px;height: 14px;margin-right: 10px"/>
                <img @click.stop="handleClickDelete(item)" src="@/assets/AI/delete.png"
                     style="width: 14px;height: 14px"/>
              </div>
            </div>
            <div class="bottom">{{ item.createTime }}</div>
          </div>
        </div>
        <div v-else style="height: 450px">
          <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
        </div>
      </div>
      <div style="display: flex;justify-content: space-between;align-items: center">
        <el-button @click="handleClickDeleteAll" :icon="Delete" size="small">
          {{ $t('ai.clean.history') }}
        </el-button>
        <el-pagination
            v-if="total"
            v-model:current-page="page"
            v-model:page-size="pageSize"
            small="small"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
      </div>
      <!--  二次确认框 -->
      <Dialog
          v-model="dialogVisible"
          :title="$t('common.ai.delete.true')"
          :dialogVisible="dialogVisible "
          :width="'max-content'"
          :isHeadLine="false"
          @update:dialogVisible="(val) => (dialogVisible = val)"
      >
        <template #content>
          <div class="my_forms">
            <div>{{ $t('common.ai.delete.tip.question') }}</div>
          </div>
        </template>
        <template #footer>
          <div id="sendRequire">
            <el-button size="small" @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
            <el-button size="small" :loading="isDeleteLoading" type="primary" @click="handleClickDetailDelete">
              {{ $t('common.delete') }}
            </el-button>
          </div>
        </template>
      </Dialog>
    </template>
  </el-dialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits, computed, onMounted, defineExpose, nextTick} from 'vue'
import {useStore} from "vuex";
import {debouncePlus, throttle} from "@/utils/mylodash";
import {emptyUrl, TIME_OUT} from '@/utils/statusParams'
import Dialog from "@/components/Dialog.vue";
import {Delete} from "@element-plus/icons-vue";

const store = useStore();
const emit = defineEmits(['close'])
const isShow = ref(false);
const teamName = ref("")
const loading = ref(false);
const lastScrollTop = ref(0);
const dialogVisible = ref(false)
// 选中的 item
const currentItem = ref()

// 编辑
const editingItemId = ref(null);
const editText = ref('');
const editInput = ref();

const teamId = computed(() => store.state.email.teamID);
// 聊天数据详情
const chatDetailList = computed(() => store.state.AI.chatDetailList)

const {value, isChecked} = defineProps({
  value: {type: Boolean, default: false},
  isChecked: {type: Array, default: []}
})

const visitableHistoryDetail = ref(false)
const closeDetail = () => {
  visitableHistoryDetail.value = false
}

const close = () => {
  emit('close')
}

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})


const handleClickItemDetail = throttle((item) => {
  if (editingItemId.value === item.id) {
    return; // 处于编辑状态，不触发详情点击
  }
  // dialog 展示详情
  emit("detail", item)
}, TIME_OUT)


const handleClickDetailEdit = async (item, index) => {
  // 确保滚动容器已渲染再获取滚动位置
  await nextTick();

  if (historyContent.value) {
    lastScrollTop.value = historyContent.value.scrollTop;
  }

  editingItemId.value = item.id;
  editText.value = item.conversation;

  // 再次等待 DOM 更新，确保编辑输入框已渲染
  await nextTick();

  // 检查编辑输入框是否存在并尝试聚焦
  const targetInput = editInput.value?.[index];
  if (targetInput && targetInput.focus) {
    historyContent.value.scrollTop = lastScrollTop.value;
    targetInput.focus();
  } else {
    console.warn("无法获取目标输入框，无法执行 focus()");
  }
};


const loadMore = async () => {
  const container = historyContent.value
  if (!container) return;
  // const {scrollTop, clientHeight, scrollHeight} = container;
  // console.log(scrollTop + clientHeight >= scrollHeight, hasMore.value, scrollTop, clientHeight, scrollHeight, 'scrollHeight')
  // if (scrollTop + clientHeight >= scrollHeight - 10) {
  //   const newPage = page.value + 1
  //   await store.commit("AI/setChatDetailListSetting", {type: "pageNo", value: newPage})
  //   await store.commit("AI/setHasMore", true);
  //   console.log({type: "pageNo", value: page.value++}, '{type: "pageNo", value: page.value++}')
  //   await getList();
  // }
};
const isError = ref(false)
const handleSaveEdit = async (item) => {
  console.log(item)
  const {id} = item
  if (editText.value) {
    isError.value = false
    editingItemId.value = null
    const payload = {id, message: editText.value}
    await store.dispatch("AI/aiDetaileditApis", payload)
    // await store.commit("AI/setChatDetailListSetting", {type: "pageNo", value: 1});
    await getList()

    // 再次等待 DOM 更新，确保编辑输入框已渲染
    await nextTick();
    historyContent.value.scrollTop = lastScrollTop.value;
  } else {
    isError.value = true
  }
}

const handleCheck = (val) => {
  if (val) {
    isError.value = false
  } else {
    isError.value = true
  }
}

// 删除
const isDeleteLoading = ref(false)
const handleClickDetailDelete = async () => {
  if (isAll.value) {
    isDeleteLoading.value = true
    await store.dispatch("AI/deleteAllChatDetail")
  } else {
    const {id} = currentItem.value
    isDeleteLoading.value = true
    await store.dispatch("AI/deleteChatDetailApis", {id: id})
  }
  isDeleteLoading.value = false
  dialogVisible.value = false
  await getList()
}


// 获取对话详情 list
const isLoading = ref(false)
const pageSize = computed(() => store.state.AI.chatDetailListSetting.pageSize)
const page = computed(() => store.state.AI.chatDetailListSetting.pageNo)
const total = computed(() => store.state.AI.chatDetailListSetting.total)
const hasMore = computed(() => store.state.AI.hasMore)
const historyContent = ref()

const handleSizeChange = async (val) => {
  await store.commit("AI/setChatDetailListSetting", {type: "pageSize", value: val});
  await getList()
}

const handleCurrentChange = async (val) => {
  await store.commit("AI/setChatDetailListSetting", {type: "pageNo", value: val});
  await getList()
}

const getList = async () => {
  if (!hasMore.value) return;
  isLoading.value = true;
  await store.dispatch("AI/getChatDetailListApis");
  isLoading.value = false;
};

onMounted(async () => {
  await store.commit("AI/setChatDetailListSetting", {type: "pageNo", value: 1});
  await getList()
})


const handleClickDelete = (item) => {
  console.log(item, 'item')
  dialogVisible.value = true
  currentItem.value = item
}

const isAll = ref(false)
const handleClickDeleteAll = () => {
  dialogVisible.value = true
  isAll.value = true
}

</script>
<style scoped lang="less">
.history-content {
  display: flex;
  flex-direction: column;
  overflow: scroll;
  max-height: 450px;
  min-height: 450px;
  height: 450px;
  padding-right: 15px;

  .item {
    margin-top: 10px;
    border-bottom: 1px solid #f9f9f9;
    cursor: pointer;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #444444;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 450px;
      }

      .tools {
        width: 40px;
      }
    }

    .bottom {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      padding-bottom: 10px;
    }
  }
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: 10px;
}

#sendRequire {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.my_forms {
  font-size: 13px;
  font-weight: normal;
}
</style>